<template>
  <FloatLabel class="bg-white min-w-fit px-2 h-10 rounded-lg text-xs mx-2 border-2 border-gray-300">
    <label :for="id">{{ label }}</label>
    <InputText 
      :id="id" 
      v-model="localValue" 
      class="bg-transparent" 
      :placeholder="placeholder"
      @input="handleInput"
      @change="handleChange"
    />
  </FloatLabel>
</template>

<script>
import { InputText, FloatLabel } from 'primevue';

export default {
  name: 'FilterInput',
  components: {
    InputText,
    FloatLabel
  },
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue', 'input', 'change'],
  computed: {
    localValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    }
  },
  methods: {
    handleInput(event) {
      this.$emit('input', event.target.value);
    },
    handleChange(event) {
      this.$emit('change', event.target.value);
    }
  }
};
</script> 